import type { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { privacyPolicyPageObject } from '@/utils';
import { RulesItem } from '../RulesItem/RulesItem';
import type { PrivacyPolicyPageProps } from './PrivacyPolicyPage.types';
import styles from './PrivacyPolicyPage.module.scss';
export const PrivacyPolicyPage: FC<PrivacyPolicyPageProps> = ({
  rules
}) => {
  const {
    t
  } = useTranslation('privacypolicy');
  return <div className={styles.root} data-sentry-component="PrivacyPolicyPage" data-sentry-source-file="PrivacyPolicyPage.tsx">
      <div className={styles.header}>
        <h1 {...privacyPolicyPageObject.title.nodeProps} className={styles.title}>
          {t('page-title', 'Privacy Policy')}
        </h1>
      </div>
      <div className={styles.container} {...privacyPolicyPageObject.rules.nodeProps}>
        {rules.map(item => <RulesItem key={item.id} item={item} />)}
      </div>
    </div>;
};